import dayjs, {Dayjs} from 'dayjs';
import {TimezoneList} from "@components/form/TimezoneValues";

export const endOfTheDay = (date) => {
  const dueHours = dayjs(date).format('h');
  const dueMinutes = dayjs(date).format('mm');
  const dayTime = dayjs(date).format('a');
  return dueHours === '11' && dueMinutes === '59' && dayTime === 'pm';
};

export const isDayAWeekend = (day) => {
  return dayjs(day).day() === 0 || dayjs(day).day() === 6;
};

export const getDaysWithoutWeekends = (day) => {
  let weekdays = 0;
  let currentDay = day;
  const days = [];
  while (weekdays < 5) {
      if (!isDayAWeekend(currentDay)) {
          days.push(currentDay);
      } else if (dayjs(currentDay).day() === 6) {
          currentDay = dayjs(currentDay).add(2, 'day');
          days.push(currentDay);
      } else {
          currentDay = dayjs(currentDay).add(1, 'day');
          days.push(currentDay);
      }
      currentDay = dayjs(currentDay).add(1, 'day');
      weekdays++;
  }
  return days;
};

export const timeDetails = (date) => {
  const hours = dayjs(date).format('h');
  const minutes = dayjs(date).format('mm');
  const dayTime = dayjs(date).format('a');
  return {hours, minutes, dayTime};
}

export const inTimezone = (date: string | Date | Dayjs | null | undefined, timezone: string) => {
    if (!date) return null;
    if (!timezone) return dayjs(date);

    const d = dayjs(date);
    const tz = TimezoneList.find(z => z.name == timezone || z.caption == timezone);
    let offset = tz.offset / 3600;
    if (isDST(d.toDate())) offset += 1;
    if (d.utcOffset() == offset * 60) return d; // already in the right timezone
    return d.utcOffset(offset)
}

const isDST = (date) => {
    var jan = new Date(date.getFullYear(), 0, 1);
    var jul = new Date(date.getFullYear(), 6, 1);
    return date.getTimezoneOffset() < Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());
}